// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { CANNOT_BE_IN_THE_PAST } from 'errors'

const validateDateHasNotPassed = v => {
  // creates a Date instance that is at midnight UTC
  // this way we are basing the "past" on that moment in time
  // and not Date.now()
  const pastTimestamp = new Date()
  pastTimestamp.setUTCHours(0, 0, 0, 0)

  return (
    !(v.valueOf() > pastTimestamp.getTime()) && CANNOT_BE_IN_THE_PAST
  )
}

export default validateDateHasNotPassed
